import {FormControl, FormField} from 'platform/components';
import {Box, HStack, Text} from 'platform/foundation';

import {ReactNode} from 'react';

import {useGetCustomersV2Query} from '@dms/api/customer';
import {ConsentRecipient} from '@dms/api/shared';
import {institutionOptions} from '@dms/shared';

import {Nullish} from 'shared/web';

import {
  ConsentRecipientOption,
  getConsentRecipientOptions,
} from '../../../utils/getConsentRecipientOptions';
import {ConsentRecipientInstitutions} from '../../ConsentRecipientInstitutions/ConsentRecipientInstitutions';
import {ConsentTypeFormType} from './ConsentTypeFormTemplate';

/** A third party is any customer with at least one institution type. */
const THIRD_PARTY_INSTITUTIONS = institutionOptions.map((option) => option.value);

interface ConsentTypeRecipientFieldProps {
  control: FormControl<ConsentTypeFormType>;
  recipient: ConsentRecipient | Nullish;
  label: string;
}

export function ConsentTypeRecipientField(props: ConsentTypeRecipientFieldProps) {
  const {data: customers, isLoading} = useGetCustomersV2Query({
    institutions: THIRD_PARTY_INSTITUTIONS,
  });

  const options = getConsentRecipientOptions(customers, props.recipient);

  return (
    <Box width="50%">
      <FormField
        name="recipientCustomerId"
        type="choice"
        control={props.control}
        label={props.label}
        data-testid="consent-type-form-recipient"
        options={options}
        formatOptionLabel={getFormatRecipientOptionLabel(options)}
        isLoading={isLoading}
      />
    </Box>
  );
}

function getFormatRecipientOptionLabel(options: ConsentRecipientOption[]) {
  return (option: {label?: string | null; value?: number | string | null}): ReactNode => (
    <HStack spacing={2} align="center">
      <Text size="small">{option.label}</Text>
      <ConsentRecipientInstitutions
        institutionTypes={
          options.find((item) => item.value === option.value)?.institutionTypes ?? []
        }
      />
    </HStack>
  );
}
